import constConf from '../../../constconf'
import axios from 'axios'

export default {
    tariffAll: (context) => {
        let url = constConf.bot.url + '/tariff/all'
        context.dispatch('axios/query', { url: url }, { root: true })
            .then(response => {
                if (response.ok === true) {
                    context.commit('tariffAll', response.response.data)
                } else {
                    context.commit('tariffAll', [])
                }
            })
    },
    createBot: (context, form) => {
        let url = constConf.bot.url + '/bot/create'
        let payload = { method: 'post', url: url, data: form }
        return context.dispatch('axios/queryWithData', payload, { root: true })
            .then(response => {

                // context.commit('clientUpdate', response.response.data)
                context.commit('addBot', response.response.data)
                return response
            })
    }
}
